export enum DotType {
  Downloads = 'downloads',
  MainUser = 'mainUser',
  Settings = 'settings',
  Notifications = 'notifications',
  Help = 'help',
  GetDemo = 'getDemo'
}

export enum DotSubType {
  Dot,
  New
}

export enum MainMenuSidePanelType {
  Downloads,
  PasswordRecovery,
  IpWhiteList,
  OnlineAccess
}

export interface MenuItemActionButton {
  id?: string;
  label: string;
  action: () => void;
}

export interface MenuItemType {
  name: string;
  iconClass?: string;
  secondName?: string;
  secondIconClass?: string;
  subName?: string;
  actionButton?: MenuItemActionButton;
  routeUrl?: string;
  additionalRouteUrls?: Array<string>;
  queryParams?: { [key: string]: string };
  externalUrl?: string;
  target?: '_blank' | '_self';
  action?: () => void;
  children?: Array<MenuItemType>;
  can?: boolean;
  title?: string;
  id: string;
  isHorizontalDivider?: boolean;
  dotType?: DotType;
  dotSubType?: DotSubType;
  e2eKey?: string;
}
